<template>  
  <modal 
    :show.sync="show"
    modal-classes="modal-dialog-centered modal-login"
    @close="close">
    <div 
      slot="base-content" 
      class="card card-plain card-login mb-0">
      <div class="modal-header justify-content-center">
        <button 
          type="button" 
          class="btn-sm close text-dark" 
          data-dismiss="modal" 
          aria-hidden="true"
          @click="close">
          <i class="now-ui-icons ui-1_simple-remove"/>
        </button>
        <div class="header header-primary text-center">
          <div class="logo-container">
            <img 
              v-lazy="'img/warning.png'" 
              alt="">
          </div>
        </div>
      </div>
      <div class="modal-body">
        <h4 class="title">{{ title }}</h4>
        <p 
          v-if="msg"
          class="text-center">{{ msg }}</p>
      </div>
      <div class="modal-footer justify-content-center">
        <n-button 
          class="mx-2"
          type="danger"
          @click.native="close">
          {{ closeButtonText }}
        </n-button>
        <n-button 
          :disabled="loading" 
          class="mx-2"
          type="success"
          @click.native="submit">
          {{ saveButtonText }}
          <i 
            v-if="loading" 
            class="bx bx-loader bx-spin"/>          
        </n-button>
      </div>
    </div>
  </modal>
</template>

<script>
  import axios from 'axios';
  import { mapState, mapMutations } from 'vuex';
  import { Button, FormGroupInput, Modal } from '@/components';

  export default {
    components: {
      [Button.name]: Button,
      [FormGroupInput.name]: FormGroupInput,
      Modal
    },
    props: {
      open: {
        type: Boolean,
        default: false
      },
      title: {
        type: String,
        default: 'Are you sure?'
      },
      msg: {
        type: String
      },
      closeButtonText: {
        type: String,
        default: 'Close'
      },
      saveButtonText: {
        type: String,
        default: 'Save'
      }
    },
    data() {
      return {
        show: false,
        loading: false
      };
    },
    watch: {
      open() {
        this.show = this.open;
        this.loading = false;
      }
    },
    methods: {
      close() {
        this.$emit('close');
      },
      submit() {
        this.loading = true;
        this.$emit('submit');
      }
    }
  }
</script>

<style scoped lang='scss'>
  ::v-deep .modal-login {
    margin-left: auto;
    margin-right: auto;
    
    .logo-container {
      margin-bottom: 0 !important;
    }
    .title {
      padding: 0;
      margin-top: 0;
      text-align: center;
      font-weight: bold;
    }
  }
</style>
